import { getScoreClass } from "../../../../functions/functions";

/**
 * TeamsBaseballComponent - Componente para mostrar equipos en deportes
 * Maneja baseball, basketball y football americano con validaciones robustas
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Object} props.item - Datos del juego
 * @param {string} props.url - URL base para imágenes por defecto
 */
export default function TeamsBaseballComponent({ item = {}, url = '' }) {
  // Validación de datos principales con valores por defecto
  const { 
    left_name = 'Equipo Local', 
    right_name = 'Equipo Visitante', 
    left_image = '', 
    right_image = '', 
    left_class = '', 
    right_class = '', 
    baseball_data = {}, 
    football_data = {}, 
    basketball_data = {}, 
    sport = 'BASE',
    class: gameClass = ''
  } = item;
  
  // Seleccionar el array de datos según el deporte con validación
  const getSportData = () => {
    switch(sport) {
      case 'AMFO':
        return football_data;
      case 'BASK':
        return basketball_data;
      case 'BASE':
      default:
        return baseball_data;
    }
  };
  
  const sportData = getSportData() || {};
  const { left_stats = {}, right_stats = {} } = sportData;

  /**
   * Renderiza la información de un equipo con validaciones
   */
  const renderTeam = (name, image, teamClass, stats) => {
    // Validaciones de entrada
    const teamName = name || 'Equipo';
    const teamImage = image || `${url}default.png`;
    const defaultImage = `${url}default.png`;
    const wins = stats?.record?.wins ?? 0;
    const losses = stats?.record?.losses ?? 0;
    
    return (
      <div className="card-body-left-one">
        <div className="card-body-left-one-img-name">
          <img
            src={teamImage}
            alt={`Logo ${teamName}`}
            loading="lazy"
            onError={(e) => {
              e.target.src = defaultImage;
            }}
          />
          <div className="team-info">
            <p className={getScoreClass("team-name", teamClass || '', gameClass)}>
              {teamName}
            </p>
          </div>
        </div>
        <span className="card-body-left-one-wins-losses">
          ({wins} - {losses})
        </span>
      </div>
    );
  };

  return (
    <div className="card-body-left">
      {renderTeam(left_name, left_image, left_class, left_stats)}
      {renderTeam(right_name, right_image, right_class, right_stats)}
    </div>
  );
}